var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryMotorhead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/choose category Copy 17@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "3.-V3-Account---uploaded",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3.1-Influencer-view_Instagram-Copy-2-(2)",
    transform: "translate(-658.000000, -934.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(585.000000, 683.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.000000, 248.000000)",
    id: "car-sport"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6273774,3.84731826 C15.4286678,3.61277217 15.138247,3.47826087 14.8308417,3.47826087 L10.9636557,3.47826087 L8.73661217,0.296726957 C8.60643826,0.110758261 8.3937113,0 8.16670957,0 L3.83693565,0 C3.26801391,0 2.75641391,0.34637913 2.54513043,0.874615652 L1.50373565,3.47826087 L1.04347826,3.47826087 C0.467182609,3.47826087 0,3.94544348 0,4.52173913 L0,6.95652174 L15.4831861,6.95652174 L15.860393,4.69327304 C15.9110052,4.39011478 15.826087,4.08186087 15.6273774,3.84731826 Z",
    id: "Path",
    fill: "#E86C60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.30434783 C0,7.88064696 0.46717913,8.34782609 1.04347826,8.34782609 L14.6620243,8.34782609 C15.0030574,8.34782609 15.29144,8.1036 15.348167,7.76664348 L15.4831861,6.95652174 L0,6.95652174 L0,7.30434783 Z",
    id: "Path",
    fill: "#C94F49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1145983,3.47826087 L8.16677913,0.695652174 L3.83695652,0.695652174 C3.55094957,0.695652174 3.29721391,0.867356522 3.19123478,1.13298087 L2.25312,3.47826087 L10.1145983,3.47826087 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13043478,10.4347826 C1.97962087,10.4347826 1.04347826,9.49864 1.04347826,8.34782609 C1.04347826,7.19701217 1.97962087,6.26086957 3.13043478,6.26086957 C4.2812487,6.26086957 5.2173913,7.19701217 5.2173913,8.34782609 C5.2173913,9.49864 4.2812487,10.4347826 3.13043478,10.4347826 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217391,10.4347826 C11.3709252,10.4347826 10.4347826,9.49864 10.4347826,8.34782609 C10.4347826,7.19701217 11.3709252,6.26086957 12.5217391,6.26086957 C13.672553,6.26086957 14.6086957,7.19701217 14.6086957,8.34782609 C14.6086957,9.49864 13.672553,10.4347826 12.5217391,10.4347826 Z",
    id: "Path",
    fill: "#444444"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13043478,9.39130435 C2.55502609,9.39130435 2.08695652,8.92323478 2.08695652,8.34782609 C2.08695652,7.77241739 2.55502609,7.30434783 3.13043478,7.30434783 C3.70584348,7.30434783 4.17391304,7.77241739 4.17391304,8.34782609 C4.17391304,8.92323478 3.70584348,9.39130435 3.13043478,9.39130435 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5217391,9.39130435 C11.9463304,9.39130435 11.4782609,8.92323478 11.4782609,8.34782609 C11.4782609,7.77241739 11.9463304,7.30434783 12.5217391,7.30434783 C13.0971478,7.30434783 13.5652174,7.77241739 13.5652174,8.34782609 C13.5652174,8.92323478 13.0971478,9.39130435 12.5217391,9.39130435 Z",
    id: "Path",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6086957,5.2173913 L12.5217391,5.2173913 C12.3294852,5.2173913 12.173913,5.06165217 12.173913,4.86956522 C12.173913,4.67747826 12.3294852,4.52173913 12.5217391,4.52173913 L14.6086957,4.52173913 C14.8009496,4.52173913 14.9565217,4.67747826 14.9565217,4.86956522 C14.9565217,5.06165217 14.8009496,5.2173913 14.6086957,5.2173913 Z",
    id: "Path",
    fill: "#C94F49"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E86C60",
    x: 4.52173913,
    y: 0.695652174,
    width: 1,
    height: 2.7826087
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryMotorhead);
export default __webpack_public_path__ + "static/media/category_motorhead.fb162c1ad595a9344038c48957bf0cd7.svg";
export { ForwardRef as ReactComponent };